import { IS_TEST_MODE } from '@jwp/ott-common/src/utils/common';
import { secureRandom } from '@jwp/ott-common/src/utils/random';
import { useEffect, useState } from 'react';

const generateId = (prefix?: string, suffix?: string) => {
  // This test code ensures that ID's in snapshots are always the same.
  const randomId = IS_TEST_MODE ? 1235 : secureRandom() * 10000;

  return [prefix, Math.round(randomId), suffix]
    .filter(Boolean)
    .join('_')
    .replace(/[\s.]+/g, '_')
    .toLowerCase();
};

const useOpaqueId = (prefix?: string, suffix?: string, override?: string): string => {
  const [id, setId] = useState(override || generateId(prefix, suffix));

  useEffect(() => {
    setId(override || generateId(prefix, suffix));
  }, [override, prefix, suffix]);

  return id;
};

export default useOpaqueId;
